"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsNumeric = void 0;
const class_validator_1 = require("class-validator");
/**
 * If value is null it will skip all other validators.
 *
 * @example
 * class Example {
 *   @IsNumeric()
 *   public property: string | null;
 * }
 *
 * const example = new Example();
 * example.property = '123523'; // is valid
 * example.property = '24'; // is valid
 * example.property = '123A23'; // not valid
 */
const IsNumeric = () => (target, key) => {
    (0, class_validator_1.Matches)(/^\d*$/)(target, key);
};
exports.IsNumeric = IsNumeric;
